/*  ========================================================================
    # Scripts - Scrollable Content
    ========================================================================  */

/**
 * Script that controls content display
 */

const ScrollableContent = {
  cfg: {
    scrollableContentEntry: document.querySelectorAll('.s-scrollable-content__entry'),
    scrollableContent: document.querySelectorAll('.s-scrollable-content__content'),
    states: {
      activeContent: 's-scrollable-content__entry--active'
    },
    activeEntry: '0'
  },

  /**
   * Handle scrollable content
   */
  handleScrollableContent() {
    document.addEventListener(
      'scroll',
      e => {
        const viewportHeight = window.innerHeight;
        const progress = [];
        this.cfg.scrollableContent.forEach(content => {
          const contentRect = content.getBoundingClientRect();
          progress.push(contentRect.top / viewportHeight);
        });

        for (let index = 0; index < progress.length; index++) {
          const p = progress[index];
          if (p >= -0.2 && p < 0.8) {
            this.cfg.activeEntry = index.toString();
            break;
          }
        }

        this.cfg.scrollableContent.forEach(scrollEntry => {
          const target = Array.from(this.cfg.scrollableContentEntry).find(
            entry => entry.dataset.scrollTarget === scrollEntry.dataset.scrollTrigger
          );

          if (target.dataset.scrollTarget === this.cfg.activeEntry) {
            target.classList.add(this.cfg.states.activeContent);
          } else {
            target.classList.remove(this.cfg.states.activeContent);
          }
        });
      },
      { passive: true }
    );
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.scrollableContent) {
      this.handleScrollableContent();
    }
  }
};

export default ScrollableContent;
